import { render, staticRenderFns } from "./TrueFalseSwitch.vue?vue&type=template&id=367a4b10&"
import script from "./TrueFalseSwitch.vue?vue&type=script&lang=js&"
export * from "./TrueFalseSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports